import * as d3 from 'd3-selection';
import {
  axisBottom,
  axisLeft,
  axisRight,
  axisTop,
} from 'd3-axis';

/**
 A d3 axis component.
 @param {Object} selection - The selection.
 @param {Function} xScale - The x scale.
 @param {Function} yScale - The y scale.
 */
function chartAxis(selection, xScale, yScale, plotGrid = true) {
  selection.each(function render(props) {
    const chartWidth = xScale.range()[1];
    const chartHeight = yScale.range()[0];
    const {
      orient,
      grid = true,
      tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSize = 6,
      tickPadding = 3,
    } = props;
    let {
      tickSizeInner = tickSize,
      tickSizeOuter = tickSize,
    } = props;
    let type;
    let transform;

    if (orient === 'top' && grid) {
      type = axisBottom(xScale);
      transform = 'translate(0,0)';
      tickSizeInner = chartHeight;
      tickSizeOuter *= -1;
    } else if (orient === 'bottom' && grid) {
      type = axisTop(xScale);
      transform = `translate(0,${chartHeight})`;
      tickSizeInner = chartHeight;
      tickSizeOuter *= -1;
    } else if (orient === 'top') {
      type = axisTop(xScale);
      transform = 'translate(0,0)';
    } else if (orient === 'bottom') {
      type = axisBottom(xScale);
      transform = `translate(0,${chartHeight})`;
    } else if (orient === 'right' && grid) {
      type = axisLeft(yScale);
      transform = `translate(${chartWidth},0)`;
      tickSizeInner = chartWidth;
      tickSizeOuter *= -1;
    } else if (orient === 'left' && grid) {
      type = axisRight(yScale);
      transform = 'translate(0,0)';
      tickSizeInner = chartWidth;
      tickSizeOuter *= -1;
    } else if (orient === 'right') {
      type = axisRight(yScale);
      transform = `translate(${chartWidth},0)`;
    } else {
      type = axisLeft(yScale);
      transform = 'translate(0,0)';
    }

    // Render the axis.
    type
      .tickArguments(tickArguments)
      .tickValues(tickValues)
      .tickFormat(tickFormat)
      .tickPadding(tickPadding)
      .tickSizeInner(tickSizeInner)
      .tickSizeOuter(tickSizeOuter);
    if (plotGrid) {
      d3.select(this)
        .attr('transform', transform)
        .classed('grid', grid)
        .call(type);
    }

    // Reposition the ticks to support the grid.
    if (orient === 'top' || orient === 'bottom') {
      d3.select(this)
        .selectAll('.tick text')
        .attr('dy', 0)
        .attr('y', orient === 'top'
          ? tickSizeOuter - tickPadding
          : tickPadding - tickSizeOuter)
        .attr('dominant-baseline', orient === 'top'
          ? 'auto'
          : 'hanging');
    } else {
      d3.select(this)
        .selectAll('.tick text')
        .attr('dx', 0)
        .attr('x', orient === 'right'
          ? tickPadding - tickSizeOuter
          : tickSizeOuter - tickPadding)
        .attr('text-anchor', orient === 'right'
          ? 'start'
          : 'end');
    }
  });

  selection.lower();
}


export default chartAxis;
